import { MetaByPath } from "../config";

interface IsFinalQuestionProps {
  attemptingRoute: string;
  metaByPath: MetaByPath;
  questionnaireOrder: string[];
}

// Which page ends the questionnaire differs per flow: the default flow finishes
// on "How did you hear about us?", the partner flow on the phone number. A page
// shared by both (PhonePage) therefore cannot hard-code that it is last, so it
// asks the active flow's config instead.
//
// The trailing interstitial is excluded from the progress bar, which makes the
// last progress-counted step the last question the user actually answers.
export const isFinalQuestion = ({
  attemptingRoute,
  metaByPath,
  questionnaireOrder,
}: IsFinalQuestionProps): boolean => {
  const questions = questionnaireOrder.filter(
    (route) => !metaByPath[route]?.excludeFromProgress,
  );

  return questions[questions.length - 1] === attemptingRoute;
};
